import Vue from 'vue'
import Vuex from 'vuex'

import say from './modules/say'
import login from './modules/login'
import scene from './modules/scene'
import panoVideo from './modules/panoVideo'
Vue.use(Vuex)

const types = {
  TOGGLE_LOGIN: 'TOGGLE_LOGIN',
  TOGGLE_VISIBLE_TYPE: 'TOGGLE_VISIBLE_TYPE',
}

export default new Vuex.Store({
  state: {
    TOGGLE_LOGIN: false,
    TOGGLE_VISIBLE_TYPE: {
      tools_share: false,
      tools_scene: true,
      tools_say: false,
      tools_vr: false,
      tools_voice: false,
      tools_full: false,
    },
  },
  actions: {
    [types.TOGGLE_LOGIN]: ({ commit }) => {
      return commit(types.TOGGLE_LOGIN)
    },
    [types.TOGGLE_VISIBLE_TYPE]: ({ rootGetters, dispatch, commit }, type) => {
      if (type === 'tools_say' && !rootGetters.getComments.length) {
        dispatch('SAY_LIST', {})
      }
      return commit(types.TOGGLE_VISIBLE_TYPE, type)
    },
  },
  mutations: {
    [types.TOGGLE_LOGIN]: (state, type) => {
      state[types.TOGGLE_LOGIN] = !state[types.TOGGLE_LOGIN]
    },
    [types.TOGGLE_VISIBLE_TYPE]: (state, type) => {
      state[types.TOGGLE_VISIBLE_TYPE][type] = !state[
        types.TOGGLE_VISIBLE_TYPE
      ][type]
    },
  },
  getters: {
    isShowLogin(state) {
      return state[types.TOGGLE_LOGIN]
    },
    isShowScene(state) {
      return state[types.TOGGLE_VISIBLE_TYPE].tools_scene
    },
    isShowShare(state) {
      return state[types.TOGGLE_VISIBLE_TYPE].tools_share
    },
    isShowSay(state) {
      return state[types.TOGGLE_VISIBLE_TYPE].tools_say
    },
    isShowVR(state) {
      return state[types.TOGGLE_VISIBLE_TYPE].tools_vr
    },
    isShowVoice(state) {
      return state[types.TOGGLE_VISIBLE_TYPE].tools_voice
    },
    isFullSceen(state) {
      return state[types.TOGGLE_VISIBLE_TYPE].tools_full
    },
  },
  modules: {
    say,
    login,
    scene,
    panoVideo,
  },
})
